export default "__VITE_ASSET__B9jeEH8$__"